import React from 'react';

export type SpinnerRingSize = 'xs' | 'sm' | 'md' | 'lg';

/** `accent` = blue ring on gray track; `current` = inherits text color (buttons); `muted` = gray. */
export type SpinnerRingVariant = 'accent' | 'current' | 'muted';

type SpinnerRingProps = {
  size?: SpinnerRingSize;
  variant?: SpinnerRingVariant;
  className?: string;
  'aria-label'?: string;
  'aria-hidden'?: boolean;
};

const SIZE_CLASS: Record<SpinnerRingSize, string> = {
  xs: 'h-3 w-3 border',
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-[3px]',
  lg: 'h-10 w-10 border-4',
};

const VARIANT_CLASS: Record<SpinnerRingVariant, string> = {
  accent: 'border-gray-200 dark:border-slate-700 border-t-blue-500 dark:border-t-blue-400',
  current: 'border-current border-t-transparent opacity-90',
  muted: 'border-gray-300 dark:border-slate-600 border-t-gray-600 dark:border-t-gray-400',
};

export default function SpinnerRing({
  size = 'sm',
  variant = 'accent',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}: SpinnerRingProps): React.ReactElement {
  return (
    <span
      className={`inline-block shrink-0 rounded-full animate-spin ${SIZE_CLASS[size]} ${VARIANT_CLASS[variant]} ${className}`}
      role={ariaLabel ? 'status' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden ?? (ariaLabel ? undefined : true)}
    />
  );
}
